import React, { useState } from 'react';
import './SlotItem.css';

const SlotItem = ({ slot, onBook, disableBooking, my }) => {
    const [hovered, setHovered] = useState(false);
    const dateObj = new Date(slot.datetime);

    const monthName = dateObj.toLocaleDateString('ru-RU', { month: 'long' });
    const day = dateObj.getDate();
    const weekday = dateObj.toLocaleDateString('ru-RU', { weekday: 'long' });
    const fullDate = dateObj.toLocaleDateString('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });
    const time = dateObj.toLocaleTimeString('ru-RU', {
        hour: '2-digit',
        minute: '2-digit',
    });

    return (
        <div
            className={`slot-card ${disableBooking ? 'disabled' : ''}`}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div className={`slot-status ${disableBooking ? 'taken' : 'free'}`}>
                {my ? '': disableBooking ? 'Недоступен' : 'Свободен'}
            </div>

            <div className="slot-content">
                <div className="slot-month">{monthName}</div>
                <div className="slot-line" />
                <div className="slot-day">{day}</div>
                <div className="slot-weekday">{weekday}</div>
                <div className="slot-time">{time}</div>
                <div className="slot-date">{fullDate}</div>
            </div>

            {!disableBooking && (
                <button
                    className={`btn-anketa ${hovered ? 'visible' : ''}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        onBook(slot.id);
                    }}
                >
                    Записаться
                </button>
            )}
        </div>
    );
};

export default SlotItem;
